import { Controller, useFormContext } from "react-hook-form";
import { RadioButton } from "ui";

import { RadioButtonsFilterFieldProps } from "../TableFilter.types";

import styles from "../TableFilter.module.scss";

const handleChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  onChange: (value: string) => void
) => {
  onChange(e.currentTarget.value);
};

export const RadioButtonsFilterField = ({
  title,
  fieldKey,
  options
}: RadioButtonsFilterFieldProps) => {
  const { control } = useFormContext<Record<string, string>>();

  return (
    <div className={styles.filterField}>
      <h4 className={styles.filterField_title}>{title}</h4>

      <div className={styles.filterField_box}>
        <Controller
          control={control}
          name={fieldKey}
          render={({ field: { value, onChange } }) => (
            <>
              {options.map((option, index) => (
                <RadioButton
                  key={index}
                  checked={
                    value ? value === option.value : !!option.checkedByDefault
                  }
                  value={option.value}
                  onChange={(e) => handleChange(e, onChange)}
                  label={option.label}
                />
              ))}
            </>
          )}
        />
      </div>
    </div>
  );
};
